import {
  FiHome, FiUsers, FiMic, FiCreditCard, FiPackage, FiGift, FiPhone,
  FiActivity, FiRefreshCw, FiTrendingUp, FiBell,
  FiRadio, FiSettings, FiFlag, FiTag, FiMail, FiPieChart, FiX, FiMoreHorizontal, FiAward, FiCamera
} from "react-icons/fi";
import { MdLeaderboard } from "react-icons/md";
import { LuIndianRupee } from "react-icons/lu";
import { getUserRole } from "./utilities/getUserRole";
import { FaHistory } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import { db } from "../lib/firebase";
import { collection, query as fsQuery, where, getCountFromServer } from "firebase/firestore";
import { useSidebar } from "./Layout";

const navItems = [
  { label: "Dashboard", path: "/", icon: <FiHome /> },
  { label: "Users", path: "/users", icon: <FiUsers /> },
  { label: "Coin Earnings", path: "/coin-earnings", icon: <LuIndianRupee />, showOnlyForEmail: ["admin@spoonland.in","admin@arrowcoders.com"] },
  { label: "Daily Call Rewards", path: "/daily-call-rewards", icon: <FiAward /> },
  { label: "Store Management", path: "/coin-packages", icon: <FiPackage /> },
  { label: "Coupons", path: "/coupons", icon: <FiTag /> },
  { label: "Gifts", path: "/gifts", icon: <FiGift /> },
  { label: "Spin Manager", path: "/spin-manager", icon: <FiPieChart />, showOnlyForEmail: ["admin@spoonland.in","admin@arrowcoders.com", "haravindh@arrowcoders.com"] },
  { label: "Conversion Settings", path: "/conversion-settings", icon: <FiRefreshCw />, showOnlyForEmail: ["admin@spoonland.in","admin@arrowcoders.com", "haravindh@arrowcoders.com"] },
  { label: "Call Configurations", path: "/call-config", icon: <FiPhone /> },
  { label: "Voice Approvals", path: "/voice-approval", icon: <FiMic /> },
  { label: "Withdraw Requests", path: "/withdrawals", icon: <FiCreditCard /> },
  { label: "Call History", path: "/call-transactions", icon: <FiActivity /> },
  { label: "Purchase History", path: "/purchase-history", icon: <FaHistory /> },
  { label: "Leader Board", path: "/leaderboard", icon: <MdLeaderboard /> },
  { label: "User Activity", path: "/user-activity", icon: <FiRadio /> },
  { label: "Analytics", path: "/analytics", icon: <FiTrendingUp /> },
  { label: "Reports", path: "/reports", icon: <FiFlag /> },
  { label: "Contact Us", path: "/contact-us", icon: <FiMail /> },
  { label: "Stories", path: "/stories", icon: <FiCamera /> },
  { label: "More Options", path: "/more-options", icon: <FiMoreHorizontal /> },
  { label: "Push Notifications", path: "/push-notifications", icon: <FiBell /> },
];

const Sidebar = () => {
  const location = useLocation();
  const { isOpen, close } = useSidebar();
  const userData = getUserRole() || {};
  const userRole = userData.role;
  const userEmail = (typeof userData.email === "string" ? userData.email : "").toLowerCase();

  const [pendingWithdrawals, setPendingWithdrawals] = useState(0);
  useEffect(() => {
    let mounted = true;
    const fetchPending = async () => {
      try {
        const res = await axios.get("/api/v1/app/wallet/withdrawal-requests", {
          params: { status: "PENDING", page: 1, limit: 10 },
        });
        const payload = res?.data || {};
        const list =
          Array.isArray(payload?.data?.withdrawalRequests)
            ? payload.data.withdrawalRequests
            : Array.isArray(payload?.withdrawalRequests)
            ? payload.withdrawalRequests
            : [];
        const count = list.filter((w) => String(w?.status || "").toUpperCase() === "PENDING").length;
        if (mounted) setPendingWithdrawals(count);
      } catch (_) {
        if (mounted) setPendingWithdrawals(0);
      }
    };
    fetchPending();
    const t = setInterval(fetchPending, 30000);
    return () => {
      mounted = false;
      clearInterval(t);
    };
  }, []);

   const isCustomisationsActive = location.pathname === "/customisations";

  const [openContactMessages, setOpenContactMessages] = useState(0);
  useEffect(() => {
    let mounted = true;
    const fetchOpenContacts = async () => {
      try {
        if (!db) return;
        const base = collection(db, "admin_support_chats");
        const openSnap = await getCountFromServer(fsQuery(base, where("status", "==", "OPEN")));
        const count = openSnap.data().count || 0;
        if (mounted) setOpenContactMessages(count);
      } catch (_) {
        if (mounted) setOpenContactMessages(0);
      }
    };
    fetchOpenContacts();
    const t = setInterval(fetchOpenContacts, 30000);
    return () => {
      mounted = false;
      clearInterval(t);
    };
  }, []);

  const [pendingVoiceApprovals, setPendingVoiceApprovals] = useState(0);
  useEffect(() => {
    let mounted = true;
    const fetchPending = async () => {
      try {
        const res = await axios.get("/api/v1/app/voice-verification/statistics");
        const payload = res?.data || {};
        const count = Number(payload?.data?.statistics?.verificationStatus?.pending?.count || 0);
        if (mounted) setPendingVoiceApprovals(Number.isFinite(count) ? count : 0);
      } catch (_) {
        if (mounted) setPendingVoiceApprovals(0);
      }
    };
    fetchPending();
    const t = setInterval(fetchPending, 30000);
    return () => {
      mounted = false;
      clearInterval(t);
    };
  }, []);

  const [pendingReports, setPendingReports] = useState(0);
  useEffect(() => {
    let mounted = true;
    const fetchPending = async () => {
      try {
        const res = await axios.get("/api/v1/app/user-reports/counts");
        const count = Number(res?.data?.data?.pendingReports || 0);
        if (mounted) setPendingReports(Number.isFinite(count) ? count : 0);
      } catch (_) {
        if (mounted) setPendingReports(0);
      }
    };
    fetchPending();
    const t = setInterval(fetchPending, 30000);
    return () => {
      mounted = false;
      clearInterval(t);
    };
  }, []);

  const NavLink = ({ item, active, children }) => {
    const isActive =
      active || location.pathname === item.path || location.pathname.startsWith(item.path + "/");

     

    return (
      <Link
      to={item.path}
      onClick={close}
      className={`group flex items-center gap-3 px-4 py-2.5 rounded-xl transition-all duration-200 min-w-0 relative ${
        isActive
          ? "text-white shadow-md"
          : "text-violet-200/75 hover:text-white hover:bg-white/[0.04]"
      }`}
      style={isActive ? {
        background: "linear-gradient(135deg, rgba(168,85,247,0.95), rgba(236,72,153,0.9))",
        boxShadow: "0 6px 18px rgba(168,85,247,0.35)",
      } : {}}
    >
      {isActive && (
        <span className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-5 rounded-r-full bg-white" aria-hidden />
      )}
      <span className={`text-lg flex-shrink-0 transition-transform duration-200 ${isActive ? "scale-110" : "group-hover:scale-110"}`}>{item.icon}</span>
      <span className="truncate flex-1 text-sm font-medium">{children || item.label}</span>
      {item.label === "Withdraw Requests" && pendingWithdrawals > 0 && (
        <span className={`ml-auto text-[10px] font-bold px-2 py-0.5 rounded-full ${
          isActive ? "bg-white text-purple-600" : "bg-gradient-to-r from-purple-500 to-pink-500 text-white"
        }`}>
          {pendingWithdrawals}
        </span>
      )}
      {item.label === "Voice Approvals" && pendingVoiceApprovals > 0 && (
        <span className={`ml-auto text-[10px] font-bold px-2 py-0.5 rounded-full ${
          isActive ? "bg-white text-purple-600" : "bg-gradient-to-r from-purple-500 to-pink-500 text-white"
        }`}>
          {pendingVoiceApprovals}
        </span>
      )}
      {item.label === "Contact Us" && openContactMessages > 0 && (
        <span className={`ml-auto text-[10px] font-bold px-2 py-0.5 rounded-full ${
          isActive ? "bg-white text-purple-600" : "bg-gradient-to-r from-purple-500 to-pink-500 text-white"
        }`}>
          {openContactMessages}
        </span>
      )}
      {item.label === "Reports" && pendingReports > 0 && (
        <span className={`ml-auto text-[10px] font-bold px-2 py-0.5 rounded-full ${
          isActive ? "bg-white text-purple-600" : "bg-gradient-to-r from-purple-500 to-pink-500 text-white"
        }`}>
          {pendingReports}
        </span>
      )}
    </Link>
  );
  };

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 z-40 lg:hidden"
          style={{ background: "rgba(5,3,20,0.7)", backdropFilter: "blur(4px)" }}
          onClick={close}
          aria-hidden
        />
      )}
      <aside
        className={`fixed top-0 left-0 h-screen w-72 z-50 z-50 flex flex-col justify-between
          transition-transform duration-300 ease-out
          sidebar-desktop ${isOpen ? "sidebar-open" : ""}`}
        style={{
          background:
            "linear-gradient(180deg, #0d0730 0%, #080520 100%)",
          borderRight: "1px solid rgba(139,92,246,0.25)",
          boxShadow: "12px 0 40px rgba(0,0,0,0.45)",
        }}
      >
        <div className="flex flex-col h-full overflow-hidden">
          {/* Logo Section */}
          <div className="flex items-center justify-between px-5 py-5" style={{ borderBottom: "1px solid rgba(139,92,246,0.18)" }}>
            <Link to="/" className="flex items-center gap-3 py-4">
              <div className="relative">
                <img
                  src="/spoonland-logo.jpg"
                  alt="Spoonland Dating App"
                  className="w-12 h-12 rounded-2xl object-cover"
                  style={{
                    border: "1px solid rgba(236,72,153,0.5)",
                    boxShadow: "0 0 20px rgba(168,85,247,0.35)",
                  }}
                />
                <span className="absolute -bottom-0.5 -right-0.5 w-3 h-3 rounded-full bg-emerald-400 border-2 border-[#080520]" />
              </div>
              <div className="leading-tight">
                <p className="font-bold text-base tracking-wide text-white">Spoonland</p>
                {/* <p className="text-[10px] tracking-[0.24em] uppercase" style={{ color: "#c084fc" }}>Admin Panel</p> */}
              </div>
            </Link>
            <button
              className="lg:hidden btn-icon-sm btn-ghost"
              onClick={close}
              aria-label="Close sidebar"
            >
              <FiX />
            </button>
          </div>

          {/* Nav */}
          <nav className="flex-1 overflow-y-auto px-3 py-4 flex flex-col gap-1" style={{ scrollbarGutter: "stable" }}>
            {navItems
              .filter(item => {
                if (item.showOnlyForEmail) {
                  const allowedEmails = Array.isArray(item.showOnlyForEmail) ? item.showOnlyForEmail : [item.showOnlyForEmail];
                  return allowedEmails.some(email => email.toLowerCase() === userEmail);
                }
                return !item.role || item.role === userRole;
              })
              .map((item) => (
                <NavLink key={item.label} item={item}>{item.label}</NavLink>
              ))}

            {/* Customisations */}
            {/* <div className="mt-0.5">
              <NavLink item={{ label: "Customisations", path: "/customisations", icon: <FiSettings /> }} active={isCustomisationsActive}>Customisations</NavLink>
            </div> */}

            <div className="mt-5 px-4 mt-auto pt-4">
              <div className="rounded-2xl p-4 text-center" style={{
                background: "linear-gradient(145deg, rgba(139,92,246,0.18), rgba(236,72,153,0.12))",
                border: "1px solid rgba(168,85,247,0.28)",
              }}>
                <p className="txt-h4 mb-1" style={{ fontSize: "0.95rem", color: "white" }}>Welcome back 👋</p>
                <p className="text-xs" style={{ color: "#c4bad8" }}>
                  {userData?.fullName || "Admin"}
                </p>
              </div>
            </div>
          </nav>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
